// extracted by mini-css-extract-plugin
module.exports = {"NotFoundPage":"_1kbREva8NN8Z7cM-OM99-m","NotFoundPageMobile":"_2CUoTRmM23WaHH8XoZkJ6L"};